import { GOOGLE_CLIENT_ID } from "../config/constants";
import { requestData } from "../config/services/datasets";
import { SERVER } from "../config/server.config";

const GOOGLE_OAUTH_URL = "https://accounts.google.com/o/oauth2/v2/auth";
const API_KEY_RETURN_PATH = "apiKeyReturnPath";
const LOCAL_API_KEY_REDIRECT_URI = "http://localhost:3000/login.html";
const DEFAULT_RETURN_PATH = "/";

export const getApiKeyRedirectUri = () => {
  const { hostname } = window.location;

  if (hostname === "localhost") {
    return LOCAL_API_KEY_REDIRECT_URI;
  }

  return `https://${hostname}`;
};

export const isApiKeyOAuthCallbackPath = (pathname) => {
  return pathname === new URL(getApiKeyRedirectUri()).pathname;
};

export const getApiKeyReturnPath = () => {
  return sessionStorage.getItem(API_KEY_RETURN_PATH);
};

export const clearApiKeyReturnPath = () => {
  sessionStorage.removeItem(API_KEY_RETURN_PATH);
};

export const exchangeApiKeyOAuthCode = (authorizationCode) => {
  const redirectUri = getApiKeyRedirectUri();

  return requestData(SERVER.GOOGLE_TOKEN(authorizationCode, redirectUri));
};

export const handleApiKeyOAuthCallback = async ({
  authorizationCode,
  pathname,
  replaceRoute,
}) => {
  if (!authorizationCode || !isApiKeyOAuthCallbackPath(pathname)) {
    return null;
  }

  const returnPath = getApiKeyReturnPath() || DEFAULT_RETURN_PATH;
  clearApiKeyReturnPath();
  replaceRoute(returnPath);

  return exchangeApiKeyOAuthCode(authorizationCode);
};

export const startApiKeyOAuth = (email) => {
  const returnPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const safeReturnPath =
    isApiKeyOAuthCallbackPath(window.location.pathname) ||
    window.location.pathname === "/login"
      ? DEFAULT_RETURN_PATH
      : returnPath;

  sessionStorage.setItem(API_KEY_RETURN_PATH, safeReturnPath);

  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID || "",
    redirect_uri: getApiKeyRedirectUri(),
    response_type: "code",
    scope: "openid email",
    access_type: "offline",
    prompt: "consent",
  });

  if (email) {
    params.set("login_hint", email);
  }

  // console.log("PARAMS", typeof params, params.toString());

  window.location.assign(`${GOOGLE_OAUTH_URL}?${params.toString()}`);
};
